import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { Link } from "react-router-dom";
import InfoModal from "../common/InfoModal";
import SectionLoadingError from "../common/SectionLoadingError";

const HpFhirConsents = (props) => {
    const [consentToRevoke, setConsentToRevoke] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [modalText, setModalText] = useState(null);

    useEffect(() => {
        logUI("MBHWeb.UI.LinkedHPFHIRAccounts.ComponentDidMount", new Date(), Tools.getURLPath());
    }, [])

    useEffect(() => {
    }, [props.HpFhirConsents])

    useEffect(() => {
        if (props.revokeGrantFailure && !props.revokeGrantSuccess) {
            setModalText(<div className="text-center"><p>Error</p></div>);
            setShowErrorModal(true)
        }
      }, [props.revokeGrantFailure])

    const getConsentCard = (oConsent) => {

        let date = null;
        if (!isNaN(new Date(oConsent.creationTime))) {
            date = new Date(oConsent.creationTime).toDateString();
        }
        let expiration = null;
        if (oConsent.expiration && oConsent.expiration != "") {
            if (!isNaN(new Date(oConsent.expiration))) {
                expiration = new Date(oConsent.expiration).toDateString();
            }
        }

        let description = oConsent.data?.Description;
        let permissionsList = oConsent.data?.Scopes.join("; ");

        return (
            <div key={oConsent.key} className="col-12 col-xl-6">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-sm">
                                <div className="card-content">
                                    <div className="list-item-col__label">{oConsent.clientName}</div>
                                    {date && <div><span className="">Created: </span>{date}</div>}
                                    {expiration && <div><span className="">Expiration: </span>{expiration}</div>}
                                    {description && <div><span className="">Description: </span>{description}</div>}
                                    {permissionsList && permissionsList.length > 0 && <div><span className="">Permissions: </span>{permissionsList}</div>}
                                </div>
                            </div>
                            <div className="col-12 col-sm center-btn">
                                <button className="btn btn-primary" onClick={() => confirmRevokeGrant(oConsent)}>REVOKE</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }


    const confirmRevokeGrant = (consent) => {
        setConsentToRevoke(consent);
        setModalText(<div className="text-center"><p>Are you sure you want to revoke access for {consent.clientName}?</p></div>);
        setShowConfirmModal(true)
    }

    const revokeGrant = useCallback(() => {
        const { revokeGrant } = props;
        cancelModal();
        revokeGrant(consentToRevoke)
        logUI("MBHWeb.UI.LinkedHPFHIRAccounts.RevokeGrantCicked", new Date(), Tools.getURLPath(), { consent: consentToRevoke });
    }, [consentToRevoke]);

    const cancelModal = useCallback(() => {
        setShowErrorModal(false);
        setShowConfirmModal(false);
        setConsentToRevoke(null);
    });


    return (
        <div className="container-fluid body-content linked-hp-fhir-container" >
            {showConfirmModal && <InfoModal isOpen={showConfirmModal} className={"linked-accounts-modal"} linkContinueLabel={"YES, REVOKE"} linkCancelLabel={"NO, GO BACK"} modalBody={modalText} modalYesFunction={revokeGrant} modalNoFunction={cancelModal} />}
            {props.revokeGrantFailure && <InfoModal isOpen={showErrorModal} className={"linked-accounts-modal"} modalBody={modalText}
                modalFooter={<button type="button" className="btn btn-primary" onClick={cancelModal}>OKAY</button>} />}
            {HpFhirConsents && <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="page-heading">Insurance Consent Records</h1>
                        </div>
                    </div>
                    <div className="row row-card-eq">
                        {props.HpFhirConsents && props.HpFhirConsents.length > 0 ?
                            props.HpFhirConsents.map((consent) => getConsentCard(consent))
                            :
                            <div className="col-12">
                                <SectionLoadingError message={"You have not authorized any applications."} sectionErrorClass="no-results-error" />
                            </div>
                        }
                    </div>
                </div>
            </div>}
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        HpFhirConsents: state.sso.hpConsentList || [],
        revokeGrantPending: state.portal.revokeHpFhirGrantPending,
        revokeGrantSuccess: state.portal.revokeHpFhirGrantSuccess,
        revokeGrantFailure: state.portal.revokeHpFhirGrantFailure
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        revokeGrant: (consent) =>
            dispatch({ type: types.REVOKE_HP_FHIR_GRANT, data: { consent: consent } })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HpFhirConsents);